import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { planList } from '../../redux/slice/PlanList';
import { createOrder } from '../../redux/slice/CreateOrder';
import { verifyPayment } from '../../redux/slice/VerifyPayment';
import { linkList } from '../../redux/slice/LinkList';
import Loader from '../../components/loader/Loader';
import moment from 'moment';
import { toast } from 'react-toastify';
import '../../assets/css/PlanPage.css';
import { useNavigate } from 'react-router-dom';

export default function PlanPage(props) {
    const { showPlanPage, linkData } = props
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const data = useSelector((state) => state.planList.data);
    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate()
    useEffect(() => {
        setLoader(true);
        dispatch(planList({ plan_type: 'link', navigate })).finally(() => setLoader(false));
    }, []);

    const formatDate = (date) => {
        if (!date) return 'N/A';
        const formatted = moment(date).format('DD/MM/YYYY');
        return formatted === 'Invalid date' ? 'N/A' : formatted;
    };

    // const handleBuyPlan = async (item) => {
    //     const price = parseFloat(item.price) || 0;
    //     if (price === 0) return;

    //     // Check if Razorpay is loaded
    //     if (!window.Razorpay) {
    //         toast.error('Razorpay is not loaded. Please refresh the page and try again.', { position: "bottom-right" });
    //         return;
    //     }

    //     try {
    //         // Create order first
    //         const orderResult = await dispatch(createOrder({
    //             plan_id: item._id
    //         }));

    //         if ((orderResult.payload?.status !== 200 && orderResult.payload?.status !== 201) || orderResult.payload?.data?.status !== true) {
    //             const errorMessage = orderResult.payload?.data?.message || 'Failed to create order';
    //             toast.error(errorMessage, { position: "bottom-right" });
    //             return;
    //         }

    //         const orderData = orderResult.payload?.data?.data;
    //         console.log(orderData, 'orderData')
    //         const orderId = orderData?.[0]?.razorpay_order_id || '';

    //         if (!orderId) {
    //             toast.error('Order ID not received from server', { position: "bottom-right" });
    //             return;
    //         }

    //         const options = {
    //             key: process.env.REACT_APP_RAZORPAY_KEY || 'YOUR_RAZORPAY_KEY_ID',
    //             amount: price * 100, // Amount in paise (multiply by 100 for rupees)
    //             currency: item.currency || 'INR',
    //             name: item.plan_name || item.name || 'Plan Purchase',
    //             description: item.description || `Purchase ${item.plan_name || item.name || 'Plan'}`,
    //             image: '', // Optional: Your logo URL
    //             order_id: orderId, // Use order_id from create_order API
    //             handler: async function (response) {
    //                 // Handle successful payment
    //                 console.log('Payment successful:', response);

    //                 try {
    //                     // Verify payment with backend
    //                     const verifyResult = await dispatch(verifyPayment({
    //                         razorpay_order_id: response.razorpay_order_id,
    //                         razorpay_payment_id: response.razorpay_payment_id,
    //                         razorpay_signature: response.razorpay_signature,
    //                         link_id: linkData?._id,
    //                     }));

    //                     if ((verifyResult.payload?.status === 200 || verifyResult.payload?.status === 201) && verifyResult.payload?.data?.status === true) {
    //                         toast.success(verifyResult.payload?.data?.message || 'Payment verified successfully!', {
    //                             position: "bottom-right",
    //                             closeOnClick: true
    //                         });
    //                         // Refresh link list after successful payment verification
    //                         await dispatch(linkList());
    //                         // Navigate to short-links page after successful payment
    //                         navigate('/short-links');
    //                     } else {
    //                         const errorMessage = verifyResult.payload?.data?.message || 'Payment verification failed';
    //                         toast.error(errorMessage, { position: "bottom-right" });
    //                     }
    //                 } catch (error) {
    //                     console.error('Error verifying payment:', error);
    //                     toast.error('Error verifying payment. Please contact support.', { position: "bottom-right" });
    //                 }
    //             },
    //             prefill: {
    //                 name: user?.name || user?.user?.name || '',
    //                 email: user?.email || user?.user?.email || '',
    //                 contact: user?.phone || user?.user?.phone || user?.contact || '',
    //             },
    //             notes: {
    //                 plan_id: item.id,
    //                 plan_name: item.plan_name || item.name,
    //             },
    //             theme: {
    //                 color: '#667eea'
    //             },
    //             modal: {
    //                 ondismiss: function () {
    //                     console.log('Payment modal closed');
    //                 }
    //             }
    //         };

    //         const razorpay = new window.Razorpay(options);
    //         razorpay.open();

    //         razorpay.on('payment.failed', function (response) {
    //             console.error('Payment failed:', response.error);
    //             toast.error('Payment failed. Please try again.', { position: "bottom-right" });
    //         });
    //     } catch (error) {
    //         console.error('Error creating order:', error);
    //         toast.error('An error occurred. Please try again.', { position: "bottom-right" });
    //     }
    // };

    const isFreePlan = (item) => {
        const planName = (item.plan_name || item.name || '').toLowerCase();
        const planType = (item.plan_type || '').toLowerCase();
        const price = parseFloat(item.price) || 0;

        return price === 0 || planName.includes('free') || planType === 'free';
    };

    const checkoutPage = (data) => {
        navigate('/checkout-page', { state: { data, linkData, link_plan: true } });
    };

    return (
        <>
            {loader ?
                <Loader />
                : data.length > 0 ?
                    <>
                        <div className="plans-grid">
                            {data?.filter((data) => data?.status === "Active")?.map((item) => (
                                <div key={item._id} className="plan-card">
                                    <div className="d-flex align-items-center gap-2 plan-card-header d-flex justify-content">
                                        <h6 className="plan-title">{item.plan_name || item.name || 'Plan'}</h6>
                                        {item._id === linkData?.plan_id ?
                                            <span className={`status-badge status-${item.status?.toLowerCase()}`}>
                                                Current Plan
                                            </span> : ''}
                                    </div>
                                    <div className="plan-card-body">
                                        <div className="plan-field">
                                            <label>Price:</label>
                                            <div className="plan-price-container">
                                                {item.mrp && parseFloat(item.mrp) > 0 && parseFloat(item.price) < parseFloat(item.mrp) && (
                                                    <span className="plan-mrp">
                                                        {item.currency || '₹'}{item.mrp}
                                                    </span>
                                                )}
                                                <p className={`plan-value price-value ${(() => {
                                                    const price = parseFloat(item.price) || 0;
                                                    return price === 0 ? 'price-free' : '';
                                                })()}`}>
                                                    {(() => {
                                                        const price = parseFloat(item.price) || 0;
                                                        if (price === 0) {
                                                            return 'Free';
                                                        }
                                                        const [intPart, decPart] = String(item.price).split('.');
                                                        return (
                                                            <>
                                                                {item.currency || '₹'}{intPart}
                                                                {decPart ? <span style={{ fontSize: '0.6em' }}>.{decPart}</span> : null}
                                                                <span style={{ fontSize: '0.6em' }}> INR</span>
                                                            </>
                                                        );
                                                    })()}
                                                </p>
                                            </div>
                                            {(parseFloat(item.price_usd) > 0 || parseFloat(item.mrp_usd) > 0) && (
                                                <div className="plan-price-container mt-1">
                                                    {item.mrp_usd && parseFloat(item.mrp_usd) > 0 && parseFloat(item.price_usd) < parseFloat(item.mrp_usd) && (
                                                        <span className="plan-mrp">
                                                            ${item.mrp_usd}
                                                        </span>
                                                    )}
                                                    <p className="plan-value price-value">
                                                        {(() => {
                                                            const [intPart, decPart] = String(item.price_usd ?? '').split('.');
                                                            return (
                                                                <>
                                                                    ${intPart}
                                                                    {decPart ? <span style={{ fontSize: '0.6em' }}>.{decPart}</span> : null}
                                                                    <span style={{ fontSize: '0.6em' }}> USD</span>
                                                                </>
                                                            );
                                                        })()}
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                        {item.description && (
                                            <div className="plan-field">
                                                <label>Description:</label>
                                                <p className="plan-value">{item.description}</p>
                                            </div>
                                        )}
                                        {/* <div className="plan-field-row">
                                            {item.start_date && (
                                                <div className="plan-field">
                                                    <label>Start Date:</label>
                                                    <p className="plan-value date-value">{formatDate(item.start_date)}</p>
                                                </div>
                                            )}
                                            {item.end_date && (
                                                <div className="plan-field">
                                                    <label>End Date:</label>
                                                    <p className="plan-value date-value">{formatDate(item.end_date)}</p>
                                                </div>
                                            )}
                                        </div> */}
                                        {/* <div className="plan-field-row">
                                            {item.plan_type && (
                                                <div className="plan-field">
                                                    <label>Plan Type:</label>
                                                    <p className="plan-value plan-type">{item.plan_type}</p>
                                                </div>
                                            )}
                                            {item.duration && (
                                                <div className="plan-field">
                                                    <label>Duration:</label>
                                                    <p className="plan-value">{item.duration}</p>
                                                </div>
                                            )}
                                        </div> */}
                                        {(item.days_validity || item.validity_days || item.validity || item.days) && (
                                            <div className="plan-field">
                                                <label>Days Validity:</label>
                                                <p className="plan-value validity-days">
                                                    {(() => {
                                                        const days = item.days_validity || item.validity_days || item.validity || item.days;
                                                        return `${days} ${days === 1 ? 'day' : 'days'}`;
                                                    })()}
                                                </p>
                                            </div>
                                        )}
                                        {/* {item.features && (
                                            <div className="plan-field">
                                                <label>Features:</label>
                                                <div className="plan-value">
                                                    {Array.isArray(item.features) ? (
                                                        <ul className="features-list">
                                                            {item.features.map((feature, idx) => (
                                                                <li key={idx}>{feature}</li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <p>{item.features}</p>
                                                    )}
                                                </div>
                                            </div>
                                        )} */}
                                    </div>
                                    <div className="plan-card-footer">
                                        {isFreePlan(item) ? (
                                            <button
                                                className="btn-plan-action btn-current"
                                                disabled
                                            >
                                                Current Plan
                                            </button>
                                        ) : (
                                            <button
                                                className="btn-plan-action btn-buy"
                                                onClick={() =>
                                                    // handleBuyPlan(item)
                                                    checkoutPage(item)
                                                }
                                            >
                                                Buy Plan
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                    :
                    <div className='text-center no-data'>No plans found</div>
            }
        </>
    )
}

